module.exports = __webpack_public_path__ + "images/f512ab56a1e3ce10216e62230655cee2.webp";